var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNaverinline = function SvgNaverinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.552 12c0 6.38-5.172 11.553-11.552 11.553S.447 18.38.447 12C.447 5.62 5.62.447 12 .447 18.38.447 23.552 5.62 23.552 12zM10.12 6.535h-4.3v10.93h4.282v-3.551c0-.99-.074-1.304-.174-1.724a10.958 10.958 0 01-.103-.465s.015-.155.131 0 3.942 5.74 3.942 5.74h4.282V6.535h-4.282V9.81c0 1.123.115 1.625.25 2.212.041.177.084.36.125.571 0 0-.013.16-.131 0-.116-.158-4.022-6.058-4.022-6.058z",
    fill: "#fff"
  })));
};

export default SvgNaverinline;